import { Card } from '@/components/Card';
import { v, font } from '@/theme/tokens';

/**
 * A KPI card for a figure that may exist in several currencies at once.
 *
 * Differs from the financial `KPICard` in exactly one way, and it is the
 * reason it exists: the value is a *list*. An installation holding AMD and
 * USD debt sees two lines, because adding them would mean inventing a rate.
 */
export function OperationalKpi({
  label,
  values,
  caption,
  tone = 'neutral',
}: {
  label: string;
  values: string[];
  caption?: string;
  tone?: 'neutral' | 'positive' | 'negative' | 'warning';
}) {
  const color =
    tone === 'negative'
      ? v('negative')
      : tone === 'positive'
        ? v('positive')
        : tone === 'warning'
          ? v('warning')
          : v('ink');

  return (
    <Card padding={18}>
      <div style={{ fontSize: 12.5, color: v('ink-muted'), fontWeight: 600, marginBottom: 10 }}>
        {label}
      </div>
      {values.map((value, index) => (
        <div
          key={value}
          style={{
            // Only the first line carries the headline size: a second
            // currency is additional information, not a second headline.
            fontSize: index === 0 ? 24 : 16,
            fontWeight: 700,
            fontFamily: font.mono,
            letterSpacing: -0.5,
            lineHeight: 1.15,
            color,
            overflowWrap: 'anywhere',
          }}
        >
          {value}
        </div>
      ))}
      {caption && (
        <div style={{ fontSize: 11.5, color: v('ink-muted'), marginTop: 8 }}>{caption}</div>
      )}
    </Card>
  );
}
